import ProjectItem from "./ProjectItem";
import './Projects.css';
import {useState} from 'react';

interface Project {
  id: number,
  img: string,
  title: string,
  description: string,
  techStack: string[],
  demoLink: string
}

const initialProject: Project[] = [

  {
    id: 1,
    title: "Book Store",
    img: 'https://bookstore-img.s3.us-east-2.amazonaws.com/bookstore-bg.png',
    description: "Online bookstore and management site for library",
    techStack: ['React', 'Redux', 'Typescript', 'Java', 'Spring Boot', 'PostgreSQL'],
    demoLink: "http://bookstore-website.s3-website.us-east-2.amazonaws.com/"
  },
  {
    id: 2,
    title: "Blog API Design",
    img: 'https://bookstore-img.s3.us-east-2.amazonaws.com/fastapi-design.jpeg',
    description: "API Design for blog website \n using FastAPI framework",
    techStack: ['Python', 'FastAPI', 'PostgreSQL', 'sqlalchemy'],
    demoLink: "https://github.com/namnguyen3019/fastapi"
  },
  {
    id: 3,
    title: "Appointment",
    img: 'https://bookstore-img.s3.us-east-2.amazonaws.com/appointment-website.jpeg',
    description: "Almost every business needs a way to let customer to make appointment",
    techStack: ['React', 'Redux', 'Typescript', 'Java', 'Spring Boot', 'PostgreSQL'],
    demoLink: "https://cheerful-caramel-43ce74.netlify.app/"
  }
];
const Projects = (props:any) => {
  const [projects, setProjects] = useState<Project[]>(initialProject);
  return (
    <div className="projects" ref={props.refProp}>
      <h2>
          Projects
        </h2>
      <div className="d-flex flex-wrap" style={{justifyContent:'space-evenly', alignItems:'center'}}>
      {
        projects.map(project => {
          return <ProjectItem key={project.id} project={project}/>
        })
      }
      </div>
    </div>
  )
}

export default Projects;